import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { Button } from 'react-bootstrap';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const DetailGroupsComp = (props) => {
  // console.log(props);
  const [listGroup, setListGroup] = useState([]);

  const fetchDetail = async () => {
    try {
      console.log(props.group?.id);
      const options = {
        url: `/list-mapping-module-groups/ist-mapping-module-groups-params/${props.group?.id}`,
        method: 'GET',
        headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
      };
      const { data } = await axios(options);

      setListGroup(data);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/groups/detail-module.fetchDetail');
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  return (
    <div>
      {listGroup.length > 0 ? (
        <div className="mb-3 row">
          <label htmlFor="module" className="col-sm-4 col-form-label">
            Daftar Halaman
          </label>
          <div className="text-gray-600 fw-bold fs-6">
            <ul>
              {listGroup.map((item) => (
                <li key={item.id} value={item.id}>
                  {item.namaModule}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : (
        'Halaman belum di maping!'
      )}

      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
        </div>
      </div>
    </div>
  );
};

export default DetailGroupsComp;
